// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__28e3h","inner":"Footer_inner__245WZ","nextIcon":"Footer_nextIcon__1Ewxq","innerLeft":"Footer_innerLeft__E8grk"};